const trimTrailingSlashes = (value = "") => String(value || "").replace(/\/+$/, "");

const WEBAPP_SOCKET_URL = trimTrailingSlashes(process.env.REACT_APP_WEBAPP_SOCKET_URL || "");

export const getRealtimeRelayBaseUrl = () => WEBAPP_SOCKET_URL;
export const getRealtimeRelayWsUrl = () => WEBAPP_SOCKET_URL;
